<template>
  <v-select
    ref="OrgaoEmissorSelect"
    v-model="value_"
    class="orgao-emissor-select"
    :options="emissores"
    label="sigla"
    :clearable="false"
    :multiple="multiple"
    :disabled="disabled"
    @open="carregarOrgaosEmissores"
    @search-change="carregarOrgaoEmissorFiltradas"
    @input="enviarParaPai"
  >
    <template #selected-option="{ sigla }">
      <span>{{ sigla }}</span>
    </template>
    <template v-slot:option="option">
      <div class="emissor-identification">
        <span>{{ option.sigla }}</span>
      </div>
      {{ option.nome }}
    </template>
  </v-select>
</template>

<style lang="scss">
.orgao-emissor-select .vs__dropdown-option--selected .emissor-identification {
  & span {
    color: white;
    border: 1px solid white !important;
  }
}
.emissor-identification {
  & span {
    font-size: 0.65rem;
    color: var(--primary);
    font-weight: 700;
    background-color: transparent;
    border: 1px solid var(--primary) !important;
    border-radius: 2px;
    padding: 0.1rem 0.2rem;
  }
}

.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__search {
  background-color: #efefef !important;
}
</style>

<script>
import vSelect from 'vue-select'
import api from './api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'OrgaoEmissorSelect',
  components: {
    vSelect,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Object, Array],
      default: () => { },
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
    externo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valueAttr: null,
      emissores: [],
      primeiroAcesso: true,
      filtros: [
        {
          colunas: ['nome'],
          valor: null,
        },
      ],
      emissoresCarregados: [],
    }
  },
  computed: {
    value_: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(value) {
        this.valueAttr = value
      },
    },
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        // eslint-disable-next-line no-underscore-dangle
        this.value_ = val
      }
    },
  },
  methods: {
    carregarOrgaosEmissores() {
      if (this.primeiroAcesso) {
        api.getOrgaosEmissoresResumidos(this.filtros, this.externo)
          .then(payload => {
            this.emissoresCarregados = payload.data
            this.setItensCarregados(payload.data)
            this.primeiroAcesso = false
          })
          .catch(err => {
            this.$errorFormated(err.response)
            throw err
          })
      } else {
        this.emissores = [...this.emissoresCarregados]
        this.setItensCarregados(this.emissores)
      }
    },
    carregarOrgaoEmissorFiltradas(value) {
      this.filtros[0].valor = value
      api.getOrgaosEmissoresResumidos(this.filtros, this.externo)
        .then(payload => {
          this.setItensCarregados(payload.data)
        })
        .catch(err => {
          this.$errorFormated(err.response)
          throw err
        })
    },
    enviarParaPai() {
      // eslint-disable-next-line no-underscore-dangle
      this.$emit('select', !this.value_ ? null : this.value_)
      // eslint-disable-next-line no-underscore-dangle
      this.$emit('input', !this.value_ ? null : this.value_)
    },
    limpar() {
      // eslint-disable-next-line no-underscore-dangle
      this.value_ = []
    },
    setItensCarregados(itensCarregados) {
      const itensFiltroAdicional = this.filtroAdicional(itensCarregados)
      this.emissores = itensFiltroAdicional !== null ? itensFiltroAdicional : itensCarregados
    },
  },
}
</script>
